// extracted by mini-css-extract-plugin
module.exports = {"formBody":"ModelCreatePage_formBody__2wBw4","backButton":"ModelCreatePage_backButton__2cDuy","optionalCheckBox":"ModelCreatePage_optionalCheckBox__2RZNP"};